// extracted by mini-css-extract-plugin
export default {"productGrid":"C2-z","centerLink":"D2-z","productSection":"E2-z","item":"F2-z","ctaButton":"G2-z"};